var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKycMen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8571 44V52.5714C56.8571 53.7081 56.4056 54.7982 55.6019 55.6019C54.7982 56.4056 53.7081 56.8571 52.5714 56.8571H44",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 1.14307H52.5714C53.7081 1.14307 54.7982 1.5946 55.6019 2.39832C56.4056 3.20205 56.8571 4.29214 56.8571 5.42878V14.0002",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.14307 14.0002V5.42878C1.14307 4.29214 1.5946 3.20205 2.39832 2.39832C3.20205 1.5946 4.29214 1.14307 5.42878 1.14307H14.0002",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 56.8571H5.42878C4.29214 56.8571 3.20205 56.4056 2.39832 55.6019C1.5946 54.7982 1.14307 53.7081 1.14307 52.5714V44",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 26.8572C33.734 26.8572 37.5716 23.0197 37.5716 18.2858C37.5716 13.5519 33.734 9.71436 29.0001 9.71436C24.2663 9.71436 20.4287 13.5519 20.4287 18.2858C20.4287 23.0197 24.2663 26.8572 29.0001 26.8572Z",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5432 44.0001C41.3245 41.4408 39.4055 39.2792 37.0086 37.7658C34.6117 36.2524 31.8351 35.4492 29.0004 35.4492C26.1657 35.4492 23.389 36.2524 20.9922 37.7658C18.5953 39.2792 16.6763 41.4408 15.4575 44.0001",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycMen);
export default __webpack_public_path__ + "static/media/KycMen.6cf3151b6a43b03ca5a07e5ef30051bd.svg";
export { ForwardRef as ReactComponent };